import { render, staticRenderFns } from "./BeforeAfterLogItem.vue?vue&type=template&id=6d7a73a6&scoped=true&"
import script from "./BeforeAfterLogItem.vue?vue&type=script&lang=js&"
export * from "./BeforeAfterLogItem.vue?vue&type=script&lang=js&"
import style0 from "./BeforeAfterLogItem.vue?vue&type=style&index=0&id=6d7a73a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7a73a6",
  null
  
)

export default component.exports